document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("click", function(e) {
    if (e.target.classList.contains("variant-dot") || e.target.closest(".variant-dot")) {
      var productUrl = e.target.closest(".variant-dot").getAttribute("href");
      e.preventDefault();
      var options = document.querySelectorAll(".product-info .variant-picker__option");
      var activeValues = '';
      var index = 0;
      options.forEach(function(option) {
        var selectedValue = option.querySelector("input:checked+.block-swatch").getAttribute("value-label");
        if (index === 0) {
          activeValues = selectedValue;
        } else {
          activeValues += ` / ${selectedValue}`;
        }
        index++;
      });
      fetch(window.location.origin + productUrl +'.js')
      .then(response => response.json())
      .then(product => {
        var productVariants = product.variants;
        var variantFound = false;
        
        productVariants.forEach(function (variant) {
          if (variant.title === activeValues) {
            window.location.href = `${productUrl}?variant=${variant.id}`;
            variantFound = true;
          }
        });

        // Fallback: If no matching variant was found, redirect to product page without variant
        if (!variantFound) {
          window.location.href = productUrl;
        }
      });
    }
  });
});
